import {
  Menu,
  MenuButton,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
} from '@chakra-ui/react';
import * as React from 'react';

import { SelectButton } from '@/components/SelectButton';
import { EventVenueType } from '@/graphql-types/globalTypes';

const LABEL = {
  [EventVenueType.IN_PERSON]: 'In Person',
  [EventVenueType.ONLINE]: 'Online',
  [EventVenueType.HYBRID]: 'In Person & Online',
};

export const VenueTypeMenu: React.FC<{
  value?: EventVenueType;
  onChange: (value: EventVenueType) => void;
}> = ({ value, onChange }) => {
  return (
    <Menu>
      <MenuButton as={SelectButton}>{value ? LABEL[value] : 'All'}</MenuButton>
      <MenuList>
        <MenuOptionGroup type="radio" value={value ?? ''} onChange={onChange}>
          <MenuItemOption value="">All</MenuItemOption>
          <MenuItemOption value={EventVenueType.IN_PERSON}>
            {LABEL[EventVenueType.IN_PERSON]}
          </MenuItemOption>
          <MenuItemOption value={EventVenueType.ONLINE}>
            {LABEL[EventVenueType.ONLINE]}
          </MenuItemOption>
          <MenuItemOption value={EventVenueType.HYBRID}>
            {LABEL[EventVenueType.HYBRID]}
          </MenuItemOption>
        </MenuOptionGroup>
      </MenuList>
    </Menu>
  );
};
